import { render, staticRenderFns } from "./InsuranceBenefit.vue?vue&type=template&id=61d234dc&scoped=true"
import script from "./InsuranceBenefit.vue?vue&type=script&lang=js"
export * from "./InsuranceBenefit.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBenefit.vue?vue&type=style&index=0&id=61d234dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d234dc",
  null
  
)

export default component.exports